function loadView(view) {
  return () => import(`@/views/${view}`);
}

export const routers = [
  // {    
  //   path: '/',
  //   name: 'front',
  //   redirect: { name: 'front.home' },
  //   component: () => import('@/common/layout/front/index'),
  //   meta: {
  //     title: 'home'
  //   },
  //   children: [
  //     {        
  //       path: '/home',
  //       name: 'front.home',
  //       component: loadView('front/Home'),
  //       meta: {
  //         title: 'Trang chủ',
  //         breadcrumb: [
  //           { label: 'Trang chủ' }
  //         ]
  //       }
  //     },
  //     {        
  //       path: '/category',
  //       name: 'front.category',
  //       component: loadView('front/Category'),
  //       meta: {
  //         title: 'category',
  //         breadcrumb: [
  //           { label: 'Danh mục' }
  //         ]
  //       }
  //     },
  //     {        
  //       path: '/product',
  //       name: 'front.product',
  //       component: loadView('front/Product'),
  //       children: [
  //         {
  //           path: '/product/:id',
  //           name: 'front.product.detail',
  //           meta: {
  //             title: 'Sản phẩm',
  //             breadcrumb: [
  //               { label: 'Sản phẩm' }
  //             ]
  //           },
  //           component: () => import('@/views/front/ProductDetails.vue'),
  //         }
  //       ]
  //     }
  //   ]
  // },
  {    
    path: '',
    name: 'admin',
    redirect: { name: 'admin.dashboard' },
    component: () => import('@/common/layout/admin/index'),
    children: [
      {
        path: '/dashboard',
        name: 'admin.dashboard',
        component: loadView('Dashboard'),
        meta: {
          title: 'dashboard',
          breadcrumb: [
            { label: 'Tổng quan' }
          ]
        }
      },
      {        
        path: '/product-manager/categories',
        name: 'admin.product_manager.categories',
        component: loadView('product-manager/categories/index'),
        meta: {
          title: 'product_categories',
          breadcrumb: [
            { label: 'Quản lý Sản phẩm' },
            { label: 'Danh mục' }
          ]
        }
      },
      {        
        path: '/product-manager/brands',
        name: 'admin.product_manager.brands',
        component: loadView('product-manager/brands/index'),
        meta: {
          title: 'brands',
          breadcrumb: [
            { label: 'Quản lý Sản phẩm' },
            { label: 'Thương hiệu' }
          ]
        }
      },
      {        
        path: '/product-manager/groups',
        name: 'admin.product_manager.groups',
        component: loadView('product-manager/groups/index'),
        meta: {
          title: 'groups',
          breadcrumb: [
            { label: 'Quản lý Sản phẩm' },
            { label: 'Nhóm' }
          ]
        }
      },
      {        
        path: '/product-manager/colors',
        name: 'admin.product_manager.colors',
        component: loadView('product-manager/colors/index'),
        meta: {
          title: 'colors',
          breadcrumb: [
            { label: 'Quản lý Sản phẩm' },
            { label: 'Màu sắc' }
          ]
        }
      },
      {        
        path: '/product-manager/states',
        name: 'admin.product_manager.states',
        component: loadView('product-manager/states/index'),
        meta: {
          title: 'states',
          breadcrumb: [
            { label: 'Quản lý Sản phẩm' },
            { label: 'Tình trạng' }
          ]
        }
      },
      {        
        path: 'product-manager/genders',
        name: 'admin.product_manager.genders',
        component: loadView('product-manager/genders/index'),
        meta: {
          title: 'genders',
          breadcrumb: [
            { label: 'Quản lý Sản phẩm' },
            { label: 'Giới tính' }
          ]
        }
      },
      {        
        path: '/product-manager/products',
        name: 'admin.product_manager.products',
        component: loadView('product-manager/products/index'),
        meta: {
          title: 'products',
          breadcrumb: [
            { label: 'Quản lý Sản phẩm' },
            { label: 'Sản phẩm' }
          ]
        }
      },
      {        
        path: '/feed-manager/feeds',
        name: 'admin.feed-manager.feeds',
        component: loadView('feed-manager/feeds/index'),
        meta: {
          title: 'feeds',
          breadcrumb: [
            { label: 'Quản lý Feeds' },
            { label: 'Danh mục' }
          ]
        }
      },
      {        
        path: '/feed-manager/posts',
        name: 'admin.feed-manager.posts',
        component: loadView('feed-manager/posts/index'),
        meta: {
          title: 'posts',
          breadcrumb: [
            { label: 'Quản lý Bài viết' },
            { label: 'Bài viết' }
          ]
        }
      },
      {        
        path: '/users',
        name: 'admin.users',
        component: loadView('users/index'),
        meta: {
          title: 'users',
          breadcrumb: [
            { label: 'Tài khoản' }
          ]
        }
      },
      {        
        path: '/profile',
        name: 'admin.profile',
        component: loadView('user/index'),
        meta: {
          title: 'profile',
          breadcrumb: [
            { label: 'Hồ sơ' }
          ]
        }
      },
      {
        name: 'Not Found',
        path: '404',
        hidden: true,
        meta: {
          title: 'Not Found'
        },
        component: loadView('exception/404')
      }
    ]
  },
  {    
    path: '/login',
    name: 'admin.login',
    meta: {
      title: 'login'
    },
    component: loadView('user/Login')
  },
  {
    path: '*',
    redirect: '/404'
  }
];
